import GoogleReviewsBadge from "../../Components/GoogleReviewsBadge";
import GoogleReviewsCarousel from "../../Components/GoogleReviewsCarousel";
import Section from "../../Components/Common/Section";
import PageLayout from "../../Components/Common/PageLayout";
import SEO from "../../Components/Common/SEO";
import "./style.scss";

const Reviews: React.FC = () => {
  return (
    <PageLayout className="Reviews">
      <SEO
        title="Customer Reviews | Trusted Local Cleaners"
        description="See what our customers have to say about our professional window and gutter cleaning services. Proudly serving Farnham and surrounding areas for over 50 years."
        canonical="https://farnhamanddistrictwindowcleaning.uk/Reviews"
      />
      <Section className="reviews-section">
        <GoogleReviewsBadge />
        <GoogleReviewsCarousel />
      </Section>
    </PageLayout>
  );
};

export default Reviews;
